import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { getCurrentCulture } from "@utils";
import MyBetsViewStore from "@state/stores/my-bets/MyBetsViewStore";
import { useRootAppStore } from "@hooks";
import { WrappedNavLink } from "@components/navigation";

export default observer(function BetListDisplayHeader(props: {
	myBetsViewStore: MyBetsViewStore;
}) {
	const { t } = useTranslation();
	const rootStore = useRootAppStore();

	return (
		<div
			className={"widget__header widget__header--" + getCurrentCulture()}
		>
			<div className="widget__header__title">
				{t<string>("COMMON.MY_BETS_TITLE")}
			</div>
			{!props.myBetsViewStore.isEmpty &&
				rootStore.userAuthStore.user != null && (
					<WrappedNavLink
						to={`/${getCurrentCulture()}/my-bets`}
						className="widget__header__btn btn btn--xsml btn--ghost btn--icon btn--animate-forward u-padd--x--reset"
					>
						<span>{t<string>("mybets:VIEW_OLDER_BETS")}</span>
						<i className="u-icon u-icon--tny u-icon--arrow-right" />
					</WrappedNavLink>
				)}
		</div>
	);
});
